import Puzzle from "./Puzzle";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Puzzle />
    </div>
  );
}
